export default __webpack_public_path__ + "static/media/slack.231681b4.svg";